define('pages/main_page_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',
  './main_page_model',

  'modules/header/header_view',
  'modules/footer/footer_view',

  'modules/navigation/navigation_view',

  'modules/modal/modal_view',
  'modules/login/login_view',
  'modules/error/error_view',
  'modules/success/success_view',

  'modules/animation/transition-end',

  'text!./main_page_template.html',

  'session',
], function (
  Backbone,
  $,
  _,
  URI,
  PageModel,
  HeaderView,
  FooterView,
  NavigationView,
  ModalView,
  LoginView,
  ErrorView,
  SuccessView,
  transitionEnd,
  page_template,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.model.set(
        'version',
        $('meta[name=version]').attr('content') || 'local'
      );

      this.render();

      this.header = new HeaderView({ el: '.page-header', model: this.model });

      this.footer = new FooterView({ el: '.page-footer', model: this.model });

      this.setTitle();

      this.listenTo(
        this.model,
        'change:pageTitle',
        function (e, title) {
          this.setTitle();
        },
        this
      );

      this.listenTo(
        this.model,
        'change:state',
        function (e, state) {
          this.$el.attr('class', 'app state-' + state);
        },
        this
      );

      this.listenTo(
        Backbone,
        'formDirty',
        function (state) {
          this.formDirty = state;
        },
        this
      );

      this.listenTo(
        Backbone,
        'popstate',
        function (state) {
          this.formDirty = false;
        },
        this
      );

      this.listenTo(
        Backbone,
        'setTitle',
        function (title) {
          this.model.set('pageTitle', title);
        },
        this
      );

      this.listenTo(
        Backbone,
        'showError',
        function (errorType, message) {
          this.showError(errorType, message);
        },
        this
      );

      this.listenTo(
        Backbone,
        'goBack',
        function (fallback) {
          if (this.model.get('previousRoute')) {
            Backbone.history.history.back();
          } else {
            Backbone.trigger('navigate', fallback);
          }
        },
        this
      );

      this.listenToOnce(
        session.get('user'),
        'change:capabilities',
        function (user) {
          var userCapabilities = user.get('capabilities'),
            userMenu = [],
            location = user.get('location'),
            navigation = this.model.get('navigation');
          if (userMenu) {
            _.forEach(navigation, function (navItem) {
              if (userCapabilities[navItem.route]) {
                if (userCapabilities[navItem.route].in_menu) {
                  userMenu.push(navItem);
                }
              } else {
                userMenu.push(navItem);
              }
            });
          }

          session.set('location_id', location.location_id);

          this.navigation = new NavigationView({
            el: this.$('.main-navigation'),
          });
          this.navigation.collection.reset(userMenu);
          this.$('.main-navigation').show();

          this.listenTo(
            this.model,
            'change:currentRoute',
            function (model) {
              var route = model.get('currentRoute');
              this.navigation.collection.each(function (model) {
                if (
                  model.get('route') === route ||
                  (model.get('route') === 'bookings' && route === 'ads')
                ) {
                  model.set('active', true);
                } else {
                  model.set('active', false);
                }
              });

              if (this.$('.js-menu-container').hasClass('open')) {
                this.closeMenu();
              }
            },
            this
          );

          $(document).ajaxError(function (event, jqxhr) {
            if (jqxhr.status !== 401) {
              var msg = '';
              if (
                jqxhr.responseJSON &&
                (jqxhr.responseJSON.message || jqxhr.responseJSON.Message)
              ) {
                msg = jqxhr.responseJSON.message || jqxhr.responseJSON.Message;
              }
              // TODO #8951 Adds 500 ms delay to counter the remove call from somewhere else, causing the message to be cleared. This is a temporary fix and someone should probably fix this.
              setTimeout(function () {
                Backbone.trigger(
                  'showError',
                  'ajaxError',
                  msg || jqxhr.responseText
                );
              }, 500);
            }
          });

          $(document).ajaxSuccess(function (event, jqxhr) {
            if (jqxhr.status === 200 && jqxhr.responseJSON.modal_message) {
              var successModal = new ModalView({
                title:
                  jqxhr.responseJSON.modal_heading ||
                  _.t('success.general.header'),
                modalContent: new SuccessView({
                  message: jqxhr.responseJSON.modal_message,
                }),
              });

              successModal.open();
            }
          });

          //trigger event to set correct active state on first load
          this.model.trigger('change:currentRoute', this.model);
        }
      );
    },

    formDirty: false,

    events: {
      'click main': 'mainClick',
      'click a': 'route',
      'click .toggle-section': 'toggleSection',
      'click .js-toggle-menu': 'toggleMenu',
      'click .js-toggle-dropdown': 'toggleDropdown',
      'click .main-content': 'mainContentClick',
    },

    toggleSection: function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.$(e.currentTarget).closest('.pane').toggleClass('is-collapsed');
    },

    toggleMenu: function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (this.$('.js-menu-container').hasClass('open')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },

    toggleDropdown: function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.$('.dropdown-content').toggle();
      this.$('.logo .logo-chevron').toggleClass('active');
      if (this.$('.dropdown-content').is(':visible')) {
        this.$('.js-user').addClass('hide');
      } else {
        this.$('.js-user').removeClass('hide');
      }
    },

    openMenu: function () {
      this.$('.js-menu-container').addClass('open');
      this.$('.unshifted').addClass('shifted');
      this.$('.js-user').addClass('open');
    },

    closeMenu: function () {
      this.$('.shifted').removeClass('shifted');
      this.$('.js-menu-container').removeClass('open');
      this.$('.js-user').removeClass('open');
    },

    template: _.template(page_template),

    model: new PageModel({ logo: 'CMS' }),

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    remove: function () {
      this.$el.empty();
      this.stopListening();
      this.$el.off();
      return this;
    },

    /**
     * Hijacks internal links and triggers a route event.
     *
     * It ignores mailto:, tel:, http(s): and targeted links.
     * Add data-bypass attribute to the &lt;a&gt; tag to force
     * the link to reload the page
     *
     *  @param  {Event} e The event from a clicked link
     */
    route: function (e) {
      var href = e.currentTarget.getAttribute('href'),
        protocol = e.currentTarget.protocol + '//';

      if (href === '#' || href.indexOf('javascript') === 0) {
        e.preventDefault();
        return false;
      }
      if (e.metaKey || e.ctrlKey) {
        return;
      }

      if (
        !_.isNull(e.currentTarget.getAttribute('data-bypass')) ||
        e.currentTarget.getAttribute('target')
      ) {
        return;
      }

      if (
        href &&
        href.slice(0, protocol.length) !== protocol &&
        href.indexOf('#') !== 0 &&
        href.indexOf('mailto:') !== 0 &&
        href.indexOf('tel:') !== 0
      ) {
        e.preventDefault();

        if ($(e.currentTarget).data().returnTo) {
          session.set('return_to', $(e.currentTarget).data().returnTo);
        } else {
          session.set('return_to', false);
        }

        Backbone.trigger('navigate', href);
      }
      return this;
    },

    setTitle: function () {
      document.title =
        this.model.get('siteName') + ' – ' + this.model.get('pageTitle');
    },

    //Function to check clicks on main content
    // To enable closing togglable containers on click outside them
    mainClick: function (e) {
      Backbone.trigger('main_click', e);
    },

    mainContentClick: function (e) {
      this.$('.dropdown-content').hide();
    },

    loginModal: null,

    showLogin: function () {
      if (this.loginModal) {
        return;
      }

      var params = {};
      var hrefSubstrings = location.href.split('?');
      if (hrefSubstrings.length > 1) {
        var querystring = hrefSubstrings[1];
        params = URI.parseQuery(querystring) || {};
      }

      this.loginModal = new ModalView({
        title: false,
        modalContent: new LoginView(params),
        prevent_cancel: true,
        hide_background: true,
        auto_focus: '#username',
      });

      this.loginModal.open();

      this.listenToOnce(
        session.get('user'),
        'change:id',
        function () {
          this.loginModal.close();
          Backbone.trigger('navigate_login');
          this.loginModal = null;
        },
        this
      );
    },

    showError: function (errorType, message) {
      var modalTitle, modalContent;
      if (errorType) {
        if (errorType === 'fileUploadError') {
          modalTitle = _.t('error.file_upload_failed.header');
          modalContent = new ErrorView({
            message: message || _.t('error.file_upload_failed.message'),
          });
        } else if (errorType === 'formDirty') {
          modalTitle = _.t('error.unsaved_changes.header');
          modalContent = new ErrorView({
            message: _.t('error.unsaved_changes.message'),
          });
        } else if (errorType === 'ajaxError') {
          modalTitle = _.t('error.general.ajax.header');
          modalContent = new ErrorView({
            message: message || _.t('error.general.message'),
          });
        }
      } else {
        modalTitle = _.t('error.general.header');
        modalContent = new ErrorView({
          message: message || _.t('error.general.message'),
        });
      }
      var errorModal = new ModalView({
        title: modalTitle,
        modalContent: modalContent,
      });

      errorModal.open();
    },
  });
  return View;
});

